// Find multiple options by their values (for multi-selects)
export function findOptionsByValues(options, values) {
  if (!Array.isArray(options) || !values) return [];
  const valueArray = Array.isArray(values)
    ? values
    : values.split(",").map((v) => v.trim());
  return valueArray
    .map((val) => options.find((opt) => String(opt.value) === String(val)))
    .filter(Boolean);
}

// Build filter data object from URL search params
export function buildFilterFromParams(params, userOptions, statusOptions) {
  const filterData = {};
  if (params.windowId) filterData.windowId = params.windowId;
  if (params.windowSequenceName)
    filterData.windowSequenceName = params.windowSequenceName;
  if (params.users && userOptions.length > 0) {
    filterData.users = findOptionsByValues(userOptions, params.users);
  }
  if (params.status && statusOptions.length > 0) {
    filterData.status = findOptionsByValues(statusOptions, params.status);
  }
  if (params.pageSize) {
    filterData.pageSize = Number(params.pageSize);
  }
  return filterData;
}

// Serialize multi-select value to comma-separated string of IDs
function serializeMultiSelect(value) {
  if (!value || (Array.isArray(value) && value.length === 0)) return "";
  if (Array.isArray(value)) {
    return value.map((v) => v?.value ?? v).join(",");
  }
  return value?.value ?? value ?? "";
}

// Clean and normalize the Windows filter object for API requests
export function cleanWindowsFilter(filter, windowsRange, windowsSort) {
  const filtered = {};

  // Text fields
  if (filter.windowId) filtered.windowId = filter.windowId;
  if (filter.windowSequenceName)
    filtered.windowSequenceName = filter.windowSequenceName;

  // Multi-select fields
  const usersVal = serializeMultiSelect(filter.users);
  if (usersVal) filtered.users = usersVal;

  const statusVal = serializeMultiSelect(filter.status);
  if (statusVal) filtered.status = statusVal;

  // Pagination
  if (windowsRange) filtered.windowsRange = windowsRange;
  if (windowsSort) filtered.windowsSort = windowsSort;
  if (filter.pageSize) filtered.pageSize = filter.pageSize;

  return filtered;
}
